import { apiClient } from './api';

// Tool migration mappings (REV-251). Reference data that maps a competing
// tool's concepts to Revenant equivalents and guides a switcher through import.

export interface MigrationToolSummary {
  tool: string;
  label: string;
  description: string;
  conceptCount: number;
}

export interface MigrationConcept {
  source: string;
  revenant: string;
  revenantConcept: string;
  notes?: string;
}

export interface MigrationImportStep {
  key: string;
  title: string;
  description: string;
  action: string;
}

export interface MigrationToolMapping {
  tool: string;
  label: string;
  description: string;
  concepts: MigrationConcept[];
  importSteps: MigrationImportStep[];
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  requestId?: string;
}

export const migrationService = {
  // List the source tools Revenant provides a migration mapping for.
  listTools: async () => {
    const response =
      await apiClient.get<ApiResponse<MigrationToolSummary[]>>('/v1/migration/tools');
    return response.data;
  },

  // Get the full concept mapping + ordered import steps for one source tool.
  getTool: async (tool: string) => {
    const response = await apiClient.get<ApiResponse<MigrationToolMapping>>(
      `/v1/migration/tools/${tool}`
    );
    return response.data;
  },
};

export default migrationService;
